import { useMutation, useQuery, useQueryClient } from "react-query"
import { SaveVisitPayload, loadCrew, loadJob, loadVisit, loadVisitWorkareaStatuses, saveVisit } from "./editVisitApi"
import { notification } from 'antd'
import { hasValue } from "../../helpers/nullable"
import { useScheduleEventsInvalidator } from "../ScheduleManagement/scheduleQueries"

export const useVisitQuery = (visitId: string) => {
  return useQuery(['get-visit-for-edit', { visitId }], () => loadVisit(visitId), {
    enabled: visitId !== ''
  })
}

export const useJobQuery = (jobId: number | undefined, visitId: string) => {
  return useQuery(['get-visit-job-data', { jobId }], {
    queryFn: () => loadJob(jobId, visitId),
    enabled: hasValue(jobId)
  })
}

export const useCrewQuery = () => {
  return useQuery(['get-crew'], () => loadCrew(), {
    staleTime: 60000,
    refetchOnWindowFocus: false
  })
}

export const useSaveVisitMutation = (onSuccess: () => void) => {
  const queryClient = useQueryClient();
  const scheduleEvents = useScheduleEventsInvalidator()
  return useMutation((request: SaveVisitPayload) => saveVisit(request), {
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: ['get-visit-for-edit', { visitId: request.visitId }] })
      queryClient.invalidateQueries({ queryKey: ['get-visit-job-data', { jobId: request.jobId }] })
      queryClient.invalidateQueries({ queryKey: ['visits', request.visitId, 'workarea-statuses'] })
      scheduleEvents.invalidateAllEvents()
      onSuccess()
    },
    onError: (error: any) => {
      const message = error.response?.data?.message ?? 'There was a problem saving the visit.'
      notification.error({ message })
    }
  })
}

export const useVisitWorkareaStatuses = (visitId: string) => {
  return useQuery(['visits', visitId, 'workarea-statuses'], () => loadVisitWorkareaStatuses(visitId), {
    enabled: !!visitId
  })
}